module.exports = __webpack_public_path__ + "img/ios.69267711.png";